/* ============================================================================
   MERGED PDP — full-page cascade (REAL product template)
   ----------------------------------------------------------------------------
   Production copy of le-merged-pdp-demo.js. Contract is unchanged: it reads
   window.LE_PRODUCT (now built in Liquid by sections/le-merged-pdp.liquid from
   the real product, its variants and the per-variant product_category
   metaobject) and mounts the shipped Plant Source Block, then re-themes the
   WHOLE page on the component's `plantsource:change` event: page accent colours,
   the bottle stage + CDT/CBS/BDT tag, every category label/acronym + link, the
   buy-box tagline, the story profile eyebrow/title + body, the compliance-doc
   category + document set, the dosing grid, the related-product grid and the
   "About our <category>" slide-up.

   Differences from the demo:
     * the About slide-up body is RENDERED SERVER-SIDE, once per plant source,
       from the category collection's metafields via snippets/le-about-content
       (single source of truth — see CLAUDE.md). This file only swaps which pane
       is visible instead of rebuilding the markup in JS.
     * add-to-cart is real: the selected variant id is written into the product
       form's [name="id"] and the form is submitted (same approach as
       assets/le-plant-source-init.js).
     * related products and COA/SDS documents are real links.
   ========================================================================== */
(function () {
  "use strict";
  var DATA = window.LE_PRODUCT;
  if (!DATA || !DATA.sources || !DATA.sources.length) {
    console.warn("[le-merged-pdp] no LE_PRODUCT data — nothing to mount.");
    return;
  }
  var CUR = DATA.currencySymbol || "$";

  function esc(s){ return String(s==null?"":s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];}); }

  /* display order comes from Liquid (product_category.sort_order); keep it. */
  function money(cents){ var n=cents/100; return CUR+(n%1===0?n.toLocaleString("en-US"):n.toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2})); }
  function src(key){
    for (var i=0;i<DATA.sources.length;i++){ if(DATA.sources[i].key===key) return DATA.sources[i]; }
    return DATA.sources[0];
  }
  var mpdp = document.getElementById("mpdp");
  if (!mpdp) return;

  var form  = document.getElementById("le-mpdp-form") || document.querySelector('form[action*="/cart/add"]');
  var idInput  = form ? form.querySelector('[name="id"]') : null;
  var qtyInput = form ? form.querySelector('[name="quantity"]') : null;

  /* ---------- re-theme the whole page ---------- */
  function applySource(s){
    /* The page is two sections (le-merged-pdp + le-merged-pdp-more) with the
       reviews section between them, so paint the per-source variables onto
       every root, not just the top one. */
    document.querySelectorAll("[data-mpdp-root]").forEach(function(root){
      root.style.setProperty("--cat-color", s.accent);
      root.style.setProperty("--cat-deep", s.deep);
      root.style.setProperty("--cat-tint", s.tint);
    });

    document.querySelectorAll("[data-cat-name]").forEach(function(el){ el.textContent = s.catName; });
    document.querySelectorAll("[data-cat-abbr]").forEach(function(el){ el.textContent = s.acr; });
    if (s.catUrl) document.querySelectorAll("[data-cat-url]").forEach(function(el){ el.setAttribute("href", s.catUrl); });

    // cat-tag colouring (uses the theme's own alpha treatment)
    document.querySelectorAll("[data-cat-tag]").forEach(function(el){
      el.style.background = "color-mix(in srgb," + s.accent + " 16%,#fff)";
      el.style.color = s.deep;
    });

    setText("[data-cat-role='tagline']", s.productDesc); /* full text; CSS clamps to 3 lines */
    setText("[data-cat-role='story-body']", s.productDesc);
    setProfile(s);
    var dc=document.querySelector("[data-docs-cat]");
    if(dc) dc.innerHTML = (s.icon ? '<img src="'+esc(s.icon)+'" alt="">' : "") + '<span>'+esc(s.name)+'</span>';
    if(s.bottle){ document.querySelectorAll("[data-bottle-img]").forEach(function(im){ im.src=s.bottle; }); }
    if(s.plantImage){ document.querySelectorAll("[data-plant-img]").forEach(function(im){ im.src=s.plantImage; }); }
    setRelatedAll(s);
    renderRelated(s);
    renderDose(s);
    showDocs(s);
    showAbout(s);
  }
  function setText(sel, txt){ var el=document.querySelector(sel); if(el && txt!=null) el.textContent=txt; }
  function setProfile(s){
    var lbl=document.querySelector("[data-cat-role='profile-eyebrow']");
    var ttl=document.querySelector("[data-cat-role='profile-title']");
    if(lbl) lbl.innerHTML = esc(s.profileLabel).replace("™",'<span class="le-tm">™</span>');
    if(ttl) ttl.textContent = s.profileTitle;
  }
  function setRelatedAll(s){
    var el=document.querySelector("[data-cat-role='related-all-label']");
    if(el) el.textContent = "All " + s.catName;
    var link=document.querySelector("[data-related-all-link]");
    if(link && s.catUrl) link.setAttribute("href", s.catUrl);
  }

  /* ---------- related product grid (per source, real products) ---------- */
  function renderRelated(s){
    var grid=document.querySelector("[data-related-grid]");
    if(!grid) return;
    var items = s.related || [];
    if(!items.length){ grid.innerHTML=""; grid.closest(".le-pdp-related") && grid.closest(".le-pdp-related").setAttribute("hidden",""); return; }
    var wrap = grid.closest(".le-pdp-related"); if(wrap) wrap.removeAttribute("hidden");
    // Related products are merged tri-source listings now, so they carry
    // twist-card artwork. Mirror the markup of snippets/le-card-twist.liquid so
    // the JS-rendered grid gets the same rig the Liquid cards get — the CSS is
    // global (le-card-twist.css in theme.liquid), so it just works. Falls back
    // to the bottle image whenever a product has no twist art.
    function twistOrBottle(p, img){
      if (p && p.twist) {
        return '<div class="le-twist">' +
          '<div class="le-twist__ground"></div>' +
          '<div class="le-twist__cast"></div>' +
          '<div class="le-twist__stage">' +
            '<div class="le-twist__face">' +
              '<img src="' + esc(p.twist) + '" alt="" loading="lazy">' +
              '<div class="le-twist__shade le-twist__shade--a"></div>' +
              '<div class="le-twist__shade le-twist__shade--b"></div>' +
              '<div class="le-twist__sheen"></div>' +
            '</div>' +
          '</div>' +
        '</div>';
      }
      return img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : "";
    }

    grid.innerHTML = items.map(function(p){
      var ac = p.aromaColor || "#125D67";
      var img = p.image || s.bottle || "";
      /* Same card model as snippets/le-pdp-rcard.liquid: a stretched link makes
         the whole card navigate, and the hex + sits above it opening the shared
         quick-add slide-up. It used to be an aria-hidden <span> — visible, but
         wired to nothing. */
      return '<div class="le-rel-item"><div class="le-pdp-rcard">' +
        '<a class="le-pdp-rcard__link" href="' + esc(p.url || "#") + '"><span class="visually-hidden">' + esc(p.title) + '</span></a>' +
        '<div class="le-pdp-rcard__bottle">' + twistOrBottle(p, img) + '</div>' +
        '<div class="le-pdp-rcard__content">' +
          '<div class="le-pdp-rcard__eyebrow">The All-Natural Choice<sup style="font-size:9px;">™</sup></div>' +
          '<div class="le-pdp-rcard__name">' + esc(p.title) + '</div>' +
          '<div class="le-pdp-rcard__divider"></div>' +
          '<div class="le-pdp-rcard__cat-label" style="color:' + s.accent + ';">' + esc(s.catName) + '</div>' +
          (p.aroma ? '<div class="le-pdp-rcard__marks"><span class="le-pdp-rcard__aroma" style="background:' + ac + ';color:' + (p.aromaTextColor || "#fff") + ';">' + esc(p.aroma).toUpperCase() + '</span></div>' : "") +
          '<div class="le-pdp-rcard__price-note">as low as</div>' +
          '<div class="le-pdp-rcard__price">' + money(p.price) + '</div>' +
        '</div>' +
        (p.qa ? '<span class="le-qa-wrap le-pdp-rcard__qa">' +
          '<button type="button" class="le-qa-hex" data-quick-add data-qa="' + esc(JSON.stringify(p.qa)) +
          '" aria-label="Choose size and quantity for ' + esc(p.title) + '">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
        '</button></span>' : "") +
      '</div></div>';
    }).join("");
  }

  /* ---------- usage dosing bars (8-seg, matches live) ---------- */
  function doseSegs(fill, total){
    var out="", filled=Math.floor(fill), half=(fill-filled)>=0.5;
    for(var i=1;i<=total;i++){
      if(i<=filled) out+='<div class="le-pdp-dose-seg le-pdp-dose-seg--filled"></div>';
      else if(i===filled+1 && half) out+='<div class="le-pdp-dose-seg le-pdp-dose-seg--half"></div>';
      else out+='<div class="le-pdp-dose-seg le-pdp-dose-seg--empty"></div>';
    }
    return out;
  }
  var DOSE_ICON = {
    Vape:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M18 4l2 2-9 9-3 1 1-3z"/><path d="M3 21c3-3 6-3 9-6"/></svg>',
    Tinctures:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3h6v4l-1 2v9a2 2 0 0 1-2 2h0a2 2 0 0 1-2-2V9L9 7z"/></svg>',
    Topical:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 2h4v3l1 3v13H9V8l1-3z"/><path d="M9 12h6"/></svg>',
    Gummy:'<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3c4 5 6 8 6 11a6 6 0 0 1-12 0c0-3 2-6 6-11z"/></svg>'
  };
  function renderDose(s){
    var grid=document.querySelector("[data-dose-grid]");
    if(!grid) return;
    /* The section renders these server-side now — from theme-editor dose_card
       blocks, falling back to the same git-owned default set the default PDP
       uses (sections/le-merged-pdp.liquid). Overwriting that would put the old
       JS icon set and copy back on every plant-source switch, which is exactly
       the drift this replaced. Only fill the grid if it arrived empty, so a
       template that deliberately ships no cards still gets the category's
       about-page dosing. */
    if (grid.children.length) return;
    var dose = (s.aboutPage && s.aboutPage.dose) || [];
    grid.innerHTML = dose.map(function(d){
      var fill = typeof d.fill === "number" ? d.fill : parseFloat(d.fill) || 0;
      return '<div class="le-pdp-dose-card"><div class="le-pdp-dose-top"><div class="le-pdp-dose-left">' +
        '<div class="le-pdp-dose-icon">' + (DOSE_ICON[d.format]||DOSE_ICON.Topical) + '</div>' +
        '<div><div class="le-pdp-dose-sublabel">Format</div><div class="le-pdp-dose-format">' + esc(d.format) + '</div></div></div>' +
        '<div class="le-pdp-dose-pct">' + esc(d.pct) + '</div></div>' +
        '<div class="le-pdp-dose-bar">' + doseSegs(fill, 8) + '</div>' +
        '<div class="le-pdp-dose-note">ml terps per ml oil</div></div>';
    }).join("");
    var sec = grid.closest(".le-pdp-usage");
    if (sec) { if (dose.length) sec.removeAttribute("hidden"); else sec.setAttribute("hidden",""); }
  }

  /* ---------- compliance documents (per source, server-rendered) ---------- */
  function showDocs(s){
    document.querySelectorAll("[data-doc-source]").forEach(function(g){
      if (g.getAttribute("data-doc-source") === s.key) g.removeAttribute("hidden");
      else g.setAttribute("hidden","");
    });
  }

  /* ---------- About slide-up (server-rendered panes, one per source) -------- */
  function showAbout(s){
    var panes = document.querySelectorAll("[data-about-pane]");
    var any = false;
    panes.forEach(function(p){
      if (p.getAttribute("data-about-pane") === s.key) { p.removeAttribute("hidden"); any = true; }
      else p.setAttribute("hidden","");
    });
    var shopBtn = document.querySelector(".le-about-shop-btn");
    if (shopBtn && s.catUrl) shopBtn.setAttribute("href", s.catUrl);
    return any;
  }

  var aboutOpen=false;
  function openAbout(){
    // Re-entry guard. Without it a double-fired trigger locks the page twice
    // against a single unlock, and the leftover lock restores a stale scroll
    // position on the next release — the page jumps down the document.
    if (aboutOpen) return;
    showAbout(src(state.key));
    document.getElementById("le-about-sheet").classList.add("le-about-sheet--open");
    document.querySelector("[data-about-scrim]").classList.add("is-open");
    if (window.LESheetLock) LESheetLock.lock();
    aboutOpen=true;
  }
  function closeAbout(){
    if(!aboutOpen) return;
    document.getElementById("le-about-sheet").classList.remove("le-about-sheet--open");
    document.querySelector("[data-about-scrim]").classList.remove("is-open");
    if (window.LESheetLock) LESheetLock.unlock();
    aboutOpen=false;
  }

  /* ---------- accordions (compliant / bottles) ---------- */
  function toggleAcc(btn){
    var body=btn.parentElement.querySelector("[data-acc-body]");
    var arrow=btn.querySelector("[data-acc-arrow]");
    if(!body) return;
    var open = body.style.maxHeight && body.style.maxHeight!=="0px";
    if(open){ body.style.maxHeight="0px"; if(arrow) arrow.style.transform=""; }
    else { body.style.maxHeight = body.scrollHeight+40+"px"; if(arrow) arrow.style.transform="rotate(180deg)"; }
  }

  /* ---------- cart ---------- */
  function syncVariant(sel){
    if(!sel || !sel.variantId || !idInput) return;
    if(String(idInput.value) === String(sel.variantId)) return;
    idInput.value = sel.variantId;
    idInput.dispatchEvent(new Event("change", { bubbles: true }));
    try {
      var u = new URL(location.href);
      u.searchParams.set("variant", sel.variantId);
      history.replaceState(null, "", u);
    } catch (e) {}
  }

  /* ---------- mount + wiring ---------- */
  var state={ key: DATA.defaultSourceKey || DATA.sources[0].key };
  var block = window.LEPlantSource.mount(
    document.getElementById("plant-source-block"),
    DATA,
    {
      tagEl: document.querySelector("[data-ps-tag]"),
      onChange: function(sel){
        state.key = sel.sourceKey;
        syncVariant(sel);
        applySource(src(sel.sourceKey));
      },
      onAddToCart: function(sel){
        if(!sel || !sel.variantId) return;
        if(idInput) idInput.value = sel.variantId;
        if(qtyInput) qtyInput.value = sel.quantity || 1;
        if(typeof window.LE_addToCart !== "function"){
          console.error("[le-merged-pdp] le-cart-add.js not loaded — add to cart unavailable");
          return;
        }
        /* Same call every other PDP makes: AJAX add, cart:update with the
           re-rendered cart sections, then open the native Horizon drawer. */
        return window.LE_addToCart(sel.variantId, sel.quantity || 1)
          .catch(function(err){ console.error("[le-merged-pdp] ATC error", err); });
      }
    }
  );

  // Redirect the component's per-card About buttons to the PAGE slide-up
  // (capture phase, before the component's own bubble handler runs).
  document.addEventListener("click", function(e){
    var cardAbout = e.target.closest(".le-ps__about[data-about]");
    if(cardAbout){ e.preventDefault(); e.stopPropagation(); block.select(cardAbout.dataset.about); openAbout(); }
  }, true);

  // Page-level clicks: all About triggers, close, accordions, FAQ toggles
  document.addEventListener("click", function(e){
    if(e.target.closest("[data-open-about]")){ e.preventDefault(); openAbout(); return; }
    if(e.target.closest("[data-close-about]") || e.target.closest("[data-about-scrim]")){ closeAbout(); return; }
    var acc=e.target.closest("[data-acc-btn]"); if(acc){ toggleAcc(acc); return; }
    var faq=e.target.closest(".lab-col-faqitem__q"); if(faq){ faq.parentElement.classList.toggle("is-open"); return; }
  });
  document.addEventListener("keydown", function(e){ if(e.key==="Escape") closeAbout(); });

  /* add-on "+ Add" buttons — identical shared path (assets/le-cart-add.js). */
  document.addEventListener("click", function(e){
    var btn = e.target.closest("[data-addon-add]");
    if(!btn) return;
    e.preventDefault();
    var card = btn.closest(".le-pdp-addon-card");
    var sizeSel = card ? card.querySelector("[data-addon-size]") : null;
    var vid = (sizeSel && sizeSel.value) ? sizeSel.value : btn.dataset.variantId;
    if(!vid) return;
    if(typeof window.LE_addToCart !== "function") return;
    btn.disabled = true;
    window.LE_addToCart(vid, 1)
      .catch(function(err){ console.error("[le-merged-pdp] add-on ATC failed", err); })
      .finally(function(){ btn.disabled = false; });
  });

  applySource(src(state.key));
})();
